export default __webpack_public_path__ + "static/media/css.ab5784bc.png";